import { NgModule } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { SharedModule } from '../../shared/shared.module';
import { AdminRoutingModule, routedComponents } from './admin-routing.module';
import { NotificationsSettingsService } from '../../core/data-services/notificationSettings.service';
import { FileUploadModule } from 'ng2-file-upload';


@NgModule({
  imports: [
    SharedModule,
    AdminRoutingModule,
    FileUploadModule,
  ],
  declarations: [
    routedComponents,
  ],
  providers: [NgbActiveModal, NotificationsSettingsService],
  exports: []
})
export class AdminModule { }
